import { render, staticRenderFns } from "./ArchitectsOrderCatalog.vue?vue&type=template&id=70a50f17&"
import script from "./ArchitectsOrderCatalog.ts?vue&type=script&lang=ts&"
export * from "./ArchitectsOrderCatalog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports